module.exports = __webpack_public_path__ + "static/media/pfsa.8ebe0470.png";